<template>
  <details-header :loading="loading" dense hide-avatar>
    <template v-slot:headerLine1>
      <span class="secondarytext--text">Billing Management</span>
    </template>
    <template
      v-if="billing.planTypeId != $enums.companyPlanTypes.SETUP && !selectPlan"
    >
      <v-row>
        <v-col cols="12">
          <current-plan-card
            v-on:change="selectPlan = true"
            v-on:cancel="cancel"
          ></current-plan-card>
        </v-col>
      </v-row>
      <v-divider> </v-divider>
      <v-row v-if="isPaidPlan">
        <v-col cols="12" sm="6" md="4" class="px-0">
          <v-col cols="12">
            <send-invoices-to-card></send-invoices-to-card>
          </v-col>
          <v-col cols="12">
            <payment-method-card
              v-on:save="refreshPaymentMethods"
              :loading="paymentMethodsLoading"
            ></payment-method-card>
          </v-col>
        </v-col>
        <v-col cols="12" sm="6" md="8" class="px-0">
          <v-col cols="12">
            <active-user-trend-card></active-user-trend-card>
          </v-col>
          <v-col cols="12">
            <history-card></history-card>
          </v-col>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12" class="pt-6">
          <active-user-trend-card></active-user-trend-card>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row v-if="selectPlan">
        <v-col cols="auto" class="pa-0">
          <v-btn
            text
            @click="selectPlan = false"
            color="secondary"
            class="font-weight-bold"
          >
            <v-icon class="mr-2">
              keyboard_arrow_left
            </v-icon>
            Go Back
          </v-btn>
        </v-col>
      </v-row>
      <select-plan
        v-on:save="loadBilling"
        v-on:cancel="selectPlan = false"
      ></select-plan>
    </template>
    <select-plan-dialog ref="selectPlanDialog"></select-plan-dialog>
  </details-header>
</template>

<script>
import { mapGetters } from "vuex";
import DetailsHeader from "@/components/common/DetailsHeader";
import CurrentPlanCard from "@/components/billing/CurrentPlanCard";
import SendInvoicesToCard from "@/components/billing/SendInvoicesToCard";
import PaymentMethodCard from "@/components/billing/PaymentMethodCard";
import ActiveUserTrendCard from "@/components/billing/ActiveUserTrendCard";
import HistoryCard from "@/components/billing/HistoryCard";
import SelectPlan from "@/components/billing/SelectPlan";
import SelectPlanDialog from "@/components/billing/SelectPlanDialog";

export default {
  name: "Billing",
  components: {
    CurrentPlanCard,
    SendInvoicesToCard,
    PaymentMethodCard,
    ActiveUserTrendCard,
    HistoryCard,
    DetailsHeader,
    SelectPlan,
    SelectPlanDialog
  },
  data: () => ({
    loading: false,
    paymentMethodsLoading: false,
    historyLoading: false,
    trendLoading: false,
    selectPlan: false
  }),
  computed: {
    isPaidPlan() {
      return (
        this.billing.planTypeId != this.$enums.companyPlanTypes.SETUP &&
        this.billing.hasPaymentSource
      );
    },
    ...mapGetters({ billing: "billing/billing" })
  },
  created() {
    this.loadBilling();
  },
  methods: {
    loadBilling() {
      this.selectPlan = false;
      this.loading = true;
      Promise.all([
        this.$store.dispatch("billing/getBilling"),
        this.$store.dispatch("billing/getBillableUserCount")
      ])
        .then(() => {
          //load payment methods
          this.historyLoading = true;
          this.$store.dispatch("billing/getBillingHistory").finally(() => {
            this.historyLoading = false;
          });

          //load trend
          this.refreshTrend();

          //load actions
          this.refreshPaymentMethods();
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading your billing."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    refreshTrend() {
      this.trendLoading = true;
      this.$store.dispatch("billing/getActiveUserTrend").finally(() => {
        this.trendLoading = false;
      });
    },
    refreshPaymentMethods() {
      this.paymentMethodsLoading = true;
      this.$store.dispatch("billing/getPaymentMethods").finally(() => {
        this.paymentMethodsLoading = false;
      });
    },
    cancel() {
      this.$root.$alert(
        "Contact CoreCounts",
        "Please contact us at info@corecounts.com to cancel your account."
      );
    },
    showUpgrade() {
      let planId = this.$enums.companyPlanTypes.ENGAGEMENT;
      this.$store
        .dispatch("billing/getBillableUserCount")
        .then(() => {
          this.$refs.selectPlanDialog.showDialog(planId);
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading plan."
          );
        });
    }
  }
};
</script>
